import React from "react";
import WillowFluffRain from "../WillowFluffRain";
import CatMouseChase from "../CatMouseChase";
import AnimalSleep from "../AnimalSleep";
import { useScene } from "./SceneContext";

function getPreset(preset) {
  switch (preset) {
    case "landing":
      return {
        chaseProps: {
          className: "landing-cat-mouse is-fullscreen",
          laneCount: 3,
          minTopPct: 78,
          maxTopPct: 90,
        },
        sleepProps: {
          className: "landing-cat-mouse",
          count: 7,
          minTopPct: 80,
          maxTopPct: 92,
        },
      };
    case "games":
      return {
        chaseProps: {
          className: "games-cat-chase is-fullscreen",
          laneCount: 3,
          minTopPct: 78,
          maxTopPct: 90,
          seed: 2026,
        },
        sleepProps: {
          className: "games-cat-chase",
          count: 7,
          minTopPct: 80,
          maxTopPct: 92,
          seed: 2027,
        },
      };
    default:
      return { chaseProps: {}, sleepProps: {} };
  }
}

export default function SceneEffects({
  preset,
  fluffCount,
  showAnimals = false,
  chaseProps = {},
  sleepProps = {},
  fluffClassName = "",
} = {}) {
  const { variant } = useScene();
  const presetCfg = preset ? getPreset(preset) : null;

  const mergedChaseProps = { ...(presetCfg?.chaseProps || {}), ...(chaseProps || {}) };
  const mergedSleepProps = { ...(presetCfg?.sleepProps || {}), ...(sleepProps || {}) };

  return (
    <>
      <WillowFluffRain count={fluffCount} className={fluffClassName} />
      {showAnimals ? (
        variant === "night" ? (
          <AnimalSleep {...mergedSleepProps} />
        ) : (
          <CatMouseChase {...mergedChaseProps} />
        )
      ) : null}
    </>
  );
}

